import { GeneralSearchData } from "@search/GeneralSearchStore";
import {
  ConsultantsByWeeksQueryInput,
  GetConsultantsByWeeksQuery,
  ExpertiseFragment
} from "@graphql";
import { getConsultantsFilter } from "../utils";

export type Record = GetConsultantsByWeeksQuery["consultantsByWeeks"][0];

export function getConsultantsByWeeksFilter(
  search: GeneralSearchData,
  opts: { areasOfExp: ExpertiseFragment[]; includeAvailabilityDateRange?: boolean }
): ConsultantsByWeeksQueryInput {
  const dateRange =
    search.from || search.to
      ? {
          from: search.from,
          to: search.to
        }
      : null;

  const {
    bookingStatus,
    bookingStatusDate,
    bookingStatusDateEnd,
    bookingStatusOption,
    nationalQualification,
    ...rest
  } = getConsultantsFilter({ ...search, availability: null }, opts);

  return {
    ...rest,
    dateRange,
    consultantIds: search.consultants.map((c) => c.value)
  };
}
